import { SET_TENANT_ACTION } from "./reducersConstants";

export const setTenantAction = (data) => {
  return {
    type: SET_TENANT_ACTION,
    data,
  };
};

export const tenantReducer = (previousState = "", { type, data }) => {
  switch (type) {
    case SET_TENANT_ACTION:
      return data;
    default:
      return previousState;
  }
};
